import { render, staticRenderFns } from "./TradeDetail.vue?vue&type=template&id=009c942d&scoped=true&"
import script from "./TradeDetail.vue?vue&type=script&lang=js&"
export * from "./TradeDetail.vue?vue&type=script&lang=js&"
import style0 from "./TradeDetail.vue?vue&type=style&index=0&id=009c942d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009c942d",
  null
  
)

export default component.exports